var map = {
	"./1.svg": 6484,
	"./1.webp": 8407,
	"./2.svg": 4343,
	"./2.webp": 9158,
	"./3.svg": 7222,
	"./3.webp": 7537,
	"./4.svg": 2457,
	"./4.webp": 8344,
	"./5.svg": 4536,
	"./5.webp": 1163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6247;